<template>
	<nav>
		<ul class="pagination paginacao-margin" :class="{'pagination-sm': !_isMobile}">
			<li :class="{disabled: currentPage == 1}">
				<a href="#" @click.prevent="setCurrent(currentPage - 1)">
					<span aria-hidden="true">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
				</a>
			</li>
			<template v-if="rangeStart < 3">
				<li v-for="pagina in primeirasPaginas" :key="pagina" :class="{active: pagina == currentPage}">
					<a href="#" @click.prevent="setCurrent(pagina)">{{ pagina }}</a>
				</li>
			</template>
			<template v-else>
				<li :class="{active: 1 == currentPage}">
					<a href="#" @click.prevent="setCurrent(1)">1</a>
				</li>
				<li class="disabled">
					<a href="#" @click.prevent="">....</a>
				</li>
			</template>
			<template>
				<li v-for="pagina in meioPaginas" :key="pagina" :class="{active: pagina == currentPage}">
					<a href="#" @click.prevent="setCurrent(pagina)">{{ pagina }}</a>
				</li>
			</template>
			<template v-if="rangeEnd >= totalPage - 2">
				<li v-for="pagina in ultimasPaginas" :key="pagina" :class="{active: pagina == currentPage}">
					<a href="#" @click.prevent="setCurrent(pagina)">{{ pagina }}</a>
				</li>
			</template>
			<template v-else>
				<li class="disabled">
					<a href="#" @click.prevent="">....</a>
				</li>
				<li :class="{active: totalPage - 1 == currentPage}">
					<a href="#" @click.prevent="setCurrent(totalPage - 1)">{{ totalPage - 1 }}</a>
				</li>
			</template>
			<li :class="{disabled: currentPage == totalPage}">
				<a href="#" @click.prevent="setCurrent(currentPage + 1)">
					<span aria-hidden="true">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</a>
			</li>
		</ul>
	</nav>
</template>
<script>
export default {
	props: {
		totalPage: {
			default: 1
		},
		currentPage: {
			default: 0
		},
		pageRange: {
			default: 3
		}
	},
	data() {
		return {
			rangeStart: 3,
			rangeEnd: 3
		}
	},
	computed: {
		primeirasPaginas() {
			let array = []
			for (let i = 1; i < this.rangeStart; i++) {
				array.push(i)
			}
			return array
		},
		meioPaginas() {
			let array = []
			for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
				array.push(i)
			}
			return array
		},
		ultimasPaginas() {
			let array = []
			for (let i = this.rangeEnd + 1; i <= this.totalPage; i++) {
				array.push(i)
			}
			return array
		}
	},
	mounted() {
		this.render()
	},
	watch: {
		totalPage() {
			this.$nextTick(() => {
				this.render()
			})
		},
		currentPage() {
			this.$nextTick(() => {
				this.render()
			})
		}
	},
	methods: {
		setCurrent(page) {
			this.$emit('click-pagina', page)
		},
		render() {
			const currentPage = Number(this.currentPage),
				pageRange = Number(this.pageRange)
			this.rangeStart = currentPage - pageRange
			this.rangeEnd = currentPage + pageRange

			if (this.rangeEnd > this.totalPage - 1) {
				this.rangeEnd = this.totalPage - 1
				this.rangeStart = this.totalPage - pageRange * 2
				this.rangeStart = this.rangeStart < 1 ? 1 : this.rangeStart
			}

			if (this.rangeStart <= 1) {
				this.rangeStart = 1
				this.rangeEnd = Math.min(pageRange * 2 + 1, this.totalPage)
			}
		}
	}
}
</script>